import { render } from "./App.vue?vue&type=template&id=81f3886c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=81f3886c&lang=css"
script.render = render

export default script